module.exports = __webpack_public_path__ + "img/14.165a8204.jpg";